export function convertToPixel(w, h, isRatio = true, FABRIC_DPI = 96) {
    const MAX_WIDTH = 800;
    const MAX_HEIGHT = 800;

    let width = w, height = h, ratio = 1;
        // 1 inch = 96 px
        // 1 inch = 2.54 cm

        width = w * (FABRIC_DPI);
        height = h * (FABRIC_DPI);

        if (width > height) {
            ratio = MAX_WIDTH/width;
        } else {
            ratio = MAX_HEIGHT/height;
        }
        if(isRatio) {
            width = Math.ceil(ratio * width);
            height = Math.ceil(ratio * height);
        }

        return {
            size: {width, height},
            ratio
        };
}

export const convertPixelToCm = (value, imageDim = false, IMAGE_DPI = 96, ratio) => {
    if(imageDim){
        return Math.ceil(((2.54/IMAGE_DPI)*value));
    }else{
        return Math.ceil(((2.54/96)*value)/ratio);
    }
};

export const pixelsToInches = (pixels, ppi = 96) => {
    return pixels / ppi;
}

export const inchesToPixels = (inches, ppi = 96) => {
    return inches * ppi;
}

export const convertPixelToFeet = (value, imageDim = false, IMAGE_DPI = 96, ratio) => {
    if(imageDim){
        return (value / (IMAGE_DPI * 12)).toFixed(2);
    }else{
        return ((value / (96 * 12))/ratio).toFixed(2);
    }
}


export const sizeInInches = (width, height) => {
    const heightInches = pixelsToInches(height).toFixed(1);
    const widthInches = pixelsToInches(width).toFixed(1);
    return { heightInches, widthInches };
}
